import { useState } from 'react';
import { useNotify } from 'react-admin';
import { useQuery, useMutation } from 'react-query';
import axiosInstance from '../../config/axiosInstance';
import { SettingModel } from '../../config/types/models/SettingModel';
import { urls } from '../../config/urls';

export const useSetting = () => {
  const [setting, setSetting] = useState<SettingModel | null>(null);
  const notify = useNotify();
  const { data, isLoading } = useQuery(
    'settings',
    () => axiosInstance.get(urls.setting.get).then((res) => res.data),
    {
      onSuccess: (data) => {
        setSetting(data);
      },
      onError: (error) => {
        console.log(error);
        notify('Error fetching settings');
      },
    }
  );

  return { setting, setSetting, isLoading };
};

export const useSaveSetting = () => {
  const notify = useNotify();
  const { mutate, isLoading } = useMutation(
    (setting: SettingModel | null) =>
      axiosInstance.post(urls.setting.get, setting).then((res) => res.data),
    {
      onSuccess: () => {
        notify('Settings saved');
      },
      onError: (error) => {
        console.log(error);
        notify('Error saving settings');
      },
    }
  );

  return { mutate, isLoading };
};
